import { useMoney } from '../currency';
import { useT } from '../i18n';
import { FREE_SHIPPING_MINOR } from '../money';

/**
 * Lišta „do dopravy zdarma zbývá X". Motivuje dokoupit do prahu a po jeho
 * překročení pochválí. Práh je společný se service barem v hlavičce.
 *
 * Číslo je orientační (stejně jako mezisoučet košíku) – závaznou dopravu
 * počítá až pokladna, tady jen ukazujeme, kolik zbývá.
 */
export function FreeShippingBar({ subtotalMinor }: { subtotalMinor: number }) {
  const { t } = useT();
  const { format } = useMoney();
  const remaining = Math.max(0, FREE_SHIPPING_MINOR - subtotalMinor);
  const reached = remaining === 0;
  const pct = Math.max(
    0,
    Math.min(100, Math.round((subtotalMinor / FREE_SHIPPING_MINOR) * 100)),
  );

  return (
    <div className={reached ? 'freeship is-reached' : 'freeship'}>
      <p className="freeship-label small">
        {reached ? (
          <strong>{t('freeship.reached')}</strong>
        ) : (
          <>
            {t('freeship.remaining')} <strong>{format(remaining)}</strong>
          </>
        )}
      </p>
      <div
        className="freeship-track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label="Postup do dopravy zdarma"
      >
        <span className="freeship-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
